import { EventsItem } from "../molecules/EventsCard";
import EventsCard from "../molecules/EventsCard";

type Props = {
  items: EventsItem[];
};

const EventsGrid = ({ items }: Props) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
      {items.map((i) => (
        <EventsCard key={i.id} item={i} />
      ))}
    </div>
  );
};

export default EventsGrid;
